<div class="pageContent">
  <div class="d-flex row mt-4">
    <div
      class="col-md-4 col-sm-6 col-xs-12 mb-1"
      style="position: relative; top: 15px; right: 25px"
    >
      <label class="mainColorText">{{ "files.files" | translate }}</label>
    </div>
    <div
      class="col-md-4 col-sm-6 col-xs-12 ml-auto form-group"
      style="padding: 0px; margin: 0px; margin-right: -14px"
    >
      <div class="input-group">
        <input
          class="form-control py-2 border-right-0"
          type="search"
          value=""
          placeholder="{{ 'globals.search' | translate }}"
          id="example-search-input"
          (keyup)="applyFilter($event.target.value)"
        />
        <span class="input-group-append">
          <div
            class="input-group-text"
            style="
              background: white !important;
              border-right: rgb(123, 152, 175) 2px solid;
              border-bottom: rgb(123, 152, 175) 2px solid;
            "
          >
            <fa-icon icon="search"></fa-icon>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>

<div class="card" style="padding: 35px 7% 35px 5%">
  <div
    class="table-responsive"
    style="margin-top: -30px"
    *ngIf="dataSource.data.length > 0; else noData"
  >
    <table mat-table [dataSource]="dataSource" matSort class="">
      <!-- Position Column -->
      <ng-container matColumnDef="number">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mainColorText bold number-col"
        >
          <div class="pt-1">
            {{ "files-table.no" | translate }}
          </div>
        </th>
        <td class="bg-cell number-col" mat-cell *matCellDef="let index = index">
          {{ index + 1 }}
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="title">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mainColorText bold desc-col"
        >
          {{ "files-table.development" | translate }}
          <fa-icon
            icon="sort"
            class="hover"
            (click)="sortData('title')"
          ></fa-icon>
        </th>
        <td class="bg-cell desc-col" mat-cell *matCellDef="let element">
          <span [ngbPopover]="element.titulo">{{ element.titulo }}</span>
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="createdAt">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mainColorText bold date-col"
        >
          {{ "files-table.createAt" | translate }}
          <fa-icon
            icon="sort"
            class="hover"
            (click)="sortData('createAt')"
          ></fa-icon>
        </th>
        <td class="bg-cell date-col" mat-cell *matCellDef="let element">
          <span [ngbPopover]="element.created_at">{{
            element.created_at
          }}</span>
        </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="updatedAt">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mainColorText bold date-col"
        >
          {{ "files-table.updateAt" | translate }}
          <fa-icon
            icon="sort"
            class="hover"
            (click)="sortData('updateAt')"
          ></fa-icon>
        </th>
        <td class="bg-cell date-col" mat-cell *matCellDef="let element">
          <span [ngbPopover]="element.updated_at">{{
            element.updated_at
          }}</span>
        </td>
      </ng-container>
      <!--
            operationes
        -->
      <ng-container matColumnDef="operations">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mainColorText bold action-col"
        ></th>
        <td
          mat-cell
          *matCellDef="let element"
          class="ml-auto bg-cell action-col"
        >
          <div class="d-flex justify-content-end">
            <div class="d-flex justify-content-start">
              <button
                class="btnStyle btnAccept"
                (click)="selectDevelopment(element.id)"
                style="margin-top: 8px; margin-right: 5px"
              >
                <i
                  class="material-icons"
                  style="transform: rotate(270deg); font-size: 22px"
                  >forward</i
                >
              </button>
            </div>

            <div class="d-flex justify-content-start">
              <button
                (click)="openModal(modalConfirm, element.id)"
                class="btnStyle btnDanger"
                style="margin-top: 8px"
              >
                <fa-icon icon="times" style="font-size: 16px"></fa-icon>
              </button>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>

<ng-template #noData>
  <span class="mainColorText" style="text-align: center">{{
    "developments.noDevelopments" | translate
  }}</span>
</ng-template>

<ng-template #modalConfirm let-modalConfirm>
  <app-modal-confirm
    [title]="'developments.modal.delete.question' | translate"
    (clickClose)="deleteDevelopment(); modalConfirm.close(true)"
    (clickDismiss)="modalConfirm.dismiss()"
  ></app-modal-confirm>
</ng-template>
